import { UserRole } from "@app/redux/slices/userSlice";
import CourseApplications from "@components/CommonComponents/CourseApplications";
import React from "react";

function AdminCourseAppllication() {
  return <CourseApplications user={UserRole.ADMIN} />;
}

export default AdminCourseAppllication;
